import { Box, Flex, Spinner } from "@chakra-ui/react";
import { useAppointment } from "api/appointments";
import PageTitle from "generics/PageTitle";
import ToolbarPortal from "generics/ToolbarPortal";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import PatientDetails from "./PatientDetails";

export default function PatientDetailsPage() {
  let { id, patientId } = useParams();
  const navigate = useNavigate();

  const appointmentQuery = useAppointment(id);

  if (appointmentQuery.isLoading)
    return (
      <Box>
        <Flex alignItems="center" justifyContent="center" h="200px">
          <Spinner color="teal.500" size="xl" />
        </Flex>
      </Box>
    );

  const appointment = appointmentQuery.data;

  if (!appointment) return <h1>No Appointments</h1>;

  if (!appointment.patients[patientId]) {
    navigate("/patients");
    return null;
  }

  const patient = appointment.patients[patientId];

  return (
    <Box>
      <ToolbarPortal>
        <Flex justifyContent="space-between" alignItems="center">
          <PageTitle flexGrow={1}>Appointment: #{patient.id}</PageTitle>
        </Flex>
      </ToolbarPortal>
      <Box px={12} py={6}>
        <Box pt={4}>
          <PatientDetails
            key={Date.now()}
            appointment={appointment}
            patient={patient}
          />
        </Box>
      </Box>
    </Box>
  );
}
